<div class="zag-validity-picker__content">
  <zag-date-range-picker
    class="zag-validity-picker__range"
    [recurring]="currentRrule() !== null"
    [beforeOpen]="beforeDateRangeOpen"
    [disabled]="isDisabled()"
    [readonly]="readonly()"
    [clearable]="clearable()"
    [min]="min()"
    [max]="max()"
    [startPlaceholder]="startPlaceholder()"
    [endPlaceholder]="endPlaceholder()"
    [openRangeLabel]="openRangeLabel()"
  />

  @if (allowRrule()) {
    <button
      type="button"
      zagButton="basic"
      zagType="secondary"
      zagSize="sm"
      class="zag-validity-picker__edit"
      [class.zag-validity-picker__edit--active]="currentRrule() !== null"
      [disabled]="isDisabled() || readonly()"
      [attr.aria-label]="'validity.pickerButtonAriaLabel' | translate"
      [attr.aria-pressed]="currentRrule() !== null"
      [zagTooltip]="'validity.pickerButtonAriaLabel' | translate"
      [tooltipDisabled]="isDisabled() || readonly()"
      tooltipPosition="above"
      (click)="openRecurrenceDialog()"
    >
      <span zagIcon="event-repeat" aria-hidden="true"></span>
    </button>
  }
</div>
